import { hasCapability, type User } from "../base";

export const permission = {
  read: (user: User) => hasCapability(user, "permission.read"),
  write: (user: User) => hasCapability(user, "permission.write"),
};
